import React, { useState, useEffect } from 'react';
import { FaEnvelope, FaGithub, FaLinkedin, FaCheck, FaPaperPlane } from 'react-icons/fa';

const GetInTouch = () => {
  const [copied, setCopied] = useState(false);
  const email = 'bharatpahwa.work@gmail.com';

  useEffect(() => {
    let script = document.querySelector('script[src="https://collectcdn.com/embed.js"]');
    if (!script) {
      script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://collectcdn.com/embed.js';
      script.onerror = () => {};
      document.head.appendChild(script);
    }
  }, []);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div id="chat" className="py-12 px-4">
      
      {/* Heading matching site convention */}
      <p className="text-4xl text-black py-4 px-2 flex justify-center m-auto lg:text-5xl font-bold mb-8">
        Get in <span className="name">&nbsp;Touch</span>
      </p>

      {/* Grid Box Container */}
      <div className="mx-auto max-w-5xl rounded-2xl border border-slate-300 bg-white overflow-hidden grid grid-cols-1 lg:grid-cols-12 divide-y lg:divide-y-0 lg:divide-x divide-slate-300">
        
        {/* Left Column: Direct Contact Details */}
        <div className="lg:col-span-6 p-6 sm:p-8 bg-white flex flex-col justify-between space-y-6">
          <div className="space-y-4">
            
            {/* Status Pill */}
            <div className="inline-flex items-center gap-2 border border-emerald-200 px-3 py-1 rounded-full bg-emerald-50 text-emerald-700 text-xs font-bold">
              <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
              <span>Available for Work & Projects</span>
            </div>

            <h3 className="text-2xl font-black text-slate-900 tracking-tight pt-1">
              Let's connect & build something awesome!
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed font-medium">
              I am actively seeking software engineering & UI/UX product roles. Whether you want to discuss tech, offer a role, or collaborate—my inbox is open.
            </p>
          </div>

          {/* Copy Email Action Bar */}
          <div className="border border-slate-200 p-2 rounded-xl bg-slate-50 flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3">
            <span className="px-3 text-xs font-mono font-semibold text-slate-800 truncate">
              {email}
            </span>
            <button
              onClick={handleCopyEmail}
              className="px-4 py-2 text-xs font-bold rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white transition-all flex items-center justify-center gap-2 shrink-0 cursor-pointer"
            >
              {copied ? <FaCheck className="text-white" /> : <FaEnvelope />}
              <span>{copied ? 'Copied!' : 'Copy Email'}</span>
            </button>
          </div>

          {/* Social Links */}
          <div className="flex flex-wrap gap-2.5 pt-4 border-t border-slate-200">
            <a
              href="mailto:bharatpahwa.work@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 py-2 text-xs font-bold rounded-xl bg-slate-900 hover:bg-indigo-600 text-white transition-all"
            >
              <FaPaperPlane className="text-xs" />
              <span>Send Mail</span>
            </a>
            <a
              href="https://github.com/bharatpahwa"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 py-2 text-xs font-bold rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-900 border border-slate-200 transition-all"
            >
              <FaGithub className="text-sm" />
              <span>GitHub</span>
            </a>
            <a
              href="https://www.linkedin.com/in/bharat-pahwa"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 py-2 text-xs font-bold rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-900 border border-slate-200 transition-all"
            >
              <FaLinkedin className="text-sm text-blue-600" />
              <span>LinkedIn</span>
            </a>
          </div>

        </div>

        {/* Right Column: Chatbot Embed Box */}
        <div className="lg:col-span-6 bg-white overflow-hidden flex items-center justify-center min-h-[440px]">
          <div
            className="w-full h-full overflow-hidden"
            dangerouslySetInnerHTML={{
              __html: `
                <iframe title="Chatbot" data-src="https://links.collect.chat/669e9e5a3e99425e992deaa9" width="100%" height="460" frameborder="0" src="https://links.collect.chat/669e9e5a3e99425e992deaa9" class="lazyloaded" data-load-mode="1"></iframe>
              `,
            }}
          />
        </div>

      </div>

    </div>
  );
};

export default GetInTouch;






